import * as React from "react";
import {
    EnumPolicyFilter,
    FalconNavigatorHeader,
    ICustomerPortalService,
    IncludedProductsEnum,
    IPluginHelperService,
    Party,
    Policy,
    productHelper,
    ProductsEnum,
    Subscription,
    Types,
    INTERACTION_PROCESS_MTA_REPLACE_CAR
} from "@falcon/services";
import {authorize, Overlay} from "@athena-portal/components";
import * as moment from "moment";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import {lazyInject} from "@athena-portal/core";
import {YourCarPanel} from "./YourCarPanel";
import {AddCarPanel} from "./AddCarPanel";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import {StorageSuccessModal} from "../../../../../components/modals/StorageSuccessModal";
import {capitalize, getAmountToDisplay, getPolicyInteraction} from "../../../../../CommonFunctions";
import {HeadsUpPanel} from "../../../../../components/HeadsUpPanel";
import {PriceTransparencyWidget} from "@falcon/plugin-falcon-journey";
import {
    EditCarMtaSuccessModalWordingGenerator
} from "../../../annual/motor/yourCarsPage/modal/EditCarMtaSuccessModalWordingGenerator";
import {AllianzOnlineBadge} from "../../../../../components/AllianzOnlineBadge";

interface IState {
    policies?: Policy[];
    notEndedPolicies?: Policy[];
    allPolicies?: Policy[],
    carToTempDriverMap?: Map<string, any>;
    party: Party | null;
    subscription?: Subscription | null;
}

@authorize
export class YourCarsPage extends React.Component<{}, IState> {

    private pluginTemplates = new PluginTemplates();
    private referrerJourney: string | null;
    private greenCardVrn: string | null;
    private greenCardCaravanVrn: string | null;
    private replaceCarOldCarVrn: string | null;
    private editCarsRegistrationOldVrn: string | null;
    private replaceCarOldCarModel: string | null;
    private replaceCarOldCarMake: string | null;
    private showSuccessPopup: string | null;
    private modalContent: React.ReactNode;
    private headsUpContent: React.ReactNode;
    private title: string;
    private mtaSuccessMessageText: string | null;
    private mtaHeadsUpMessageText: string | null;
    private readonly MAX_NOT_ENDED_POLICIES: number = 3;
    private readonly MAX_CHANGE_OF_VEHICLE_COUNT: number = 2;
    private readonly MAX_ADD_CAR_PER_MONTH_COUNT: number = 2;

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    @lazyInject(Types.PluginHelperService)
    private pluginHelperService: IPluginHelperService;

    public constructor(props: {}) {
        super(props);

        this.state = {
            party: null
        };
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Your cars");

        this.customerPortalService.getPolicies(ProductsEnum.MOTOR).subscribe(
            (policies: Policy[]) => {
                this.setState({policies});

                this.pluginHelperService.getActiveTempDriversInfoFromPolicyHistory(policies).subscribe((carToTempDriverMap: Map<string, any>) => {
                    this.setState({carToTempDriverMap});
                });
            }
        );

        this.customerPortalService.getPolicies(ProductsEnum.MOTOR, EnumPolicyFilter.NOT_ENDED).subscribe(
            (notEndedPolicies: Policy[]) => {
                this.setState({notEndedPolicies});
            }
        );

        this.customerPortalService.getPolicyHistory().subscribe(
            (allPolicies: Policy[]) => {
                this.setState({allPolicies})
            }
        );

        this.customerPortalService.getProfile().subscribe((party: Party) => {
            this.setState({party});
        });

        this.customerPortalService.getSubscription().subscribe(
            (subscription: Subscription) => {
                this.setState({subscription});
            }
        );
    }

    public render() {
        this.referrerJourney = window.sessionStorage.getItem("referrerJourney");
        this.showSuccessPopup = window.sessionStorage.getItem("showPopup");

        if (this.referrerJourney === "greenCard") {
            this.setGreenCardPopup();
        } else if (this.referrerJourney === "replaceCar") {
            this.setReplaceCarPopup();
        } else if (this.referrerJourney === "mta") {
            this.setMtaPopup();
        } else if (this.referrerJourney === "mtaAddPermanentDriver") {
            this.setPermanentDriverPopup();
        } else if (this.referrerJourney === "mtaAddTemporaryDriver") {
            this.setTemporaryDriverPopup();
        } else if (this.referrerJourney === "mtaReinstateCarCover") {
            this.setReactivateCarPopup();
        } else if (this.referrerJourney === "mtaReinstateAllCars") {
            this.setReactivateAllCarsPopup();
        } else if (this.referrerJourney === "mtaAddCar") {
            this.setAddCarPopup();
        } else if (this.referrerJourney === "mtaEditVehicleRegistrationNumber") {
            this.setEditCarsRegistrationPopup();
        } else {
            window.sessionStorage.removeItem("showPopup");
            window.sessionStorage.removeItem("referrerJourney");
        }

        if (this.state.policies && this.state.notEndedPolicies && this.state.carToTempDriverMap && this.state.allPolicies && this.state.subscription) {

            const vehiclePoliciesExist: boolean = productHelper.getIncludedProducts(this.state.policies) === IncludedProductsEnum.MOTOR + IncludedProductsEnum.RENTERS || productHelper.getIncludedProducts(this.state.policies) === IncludedProductsEnum.MOTOR;

            const addCarPerMonthLimitReached: boolean = this.state.party?.customProperties!
                .some((property: {key: string, value: string}) => property.key === "addCarPerMonthCount" && parseInt(property.value, 10) >= this.MAX_ADD_CAR_PER_MONTH_COUNT) || false;

            const showAddAnotherCarSection: boolean = (this.state.notEndedPolicies && this.state.notEndedPolicies.length < this.MAX_NOT_ENDED_POLICIES) &&
                !this.state.subscription.allPoliciesAreCancelled && !addCarPerMonthLimitReached;
            const renewalPaymentFailed: boolean = this.state.subscription.renewalPaymentFailed;


            return (
                <React.Fragment>
                    {this.showSuccessPopup && vehiclePoliciesExist && <StorageSuccessModal title={this.title} explanationWording={this.modalContent} anythingElseTitle={EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalTitle()} explanationAnythingElseWording={EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalBody()}/>}
                    <FalconHeader/>
                    {!vehiclePoliciesExist &&
                    <div className="page-contents">
                        <AllianzOnlineBadge/>
                        {this.pluginTemplates.renderBackLink("Back", true, "/dashboard/monthlySubscription")}
                            <div className={"panel"}>
                            You haven’t covered any cars yet.
                            </div>
                        {this.pluginTemplates.renderBackLink("Back", true, "/dashboard/monthlySubscription")}
                    </div>}
                    {vehiclePoliciesExist &&
                    <div className="page-contents">
                        <FalconNavigatorHeader
                            back={"/dashboard/monthlySubscription"}
                            title={this.state.policies && this.state.policies.length === 1 ? "Your car" : "Your cars"}
                        />
                        <PriceTransparencyWidget
                            className="mb-4"
                            vehicles={this.state.notEndedPolicies.map((policy: Policy) => policy.interaction.vehicles[0])}
                            isMultipleDrivers={!this.state.notEndedPolicies.every((policy: Policy) => policy.insuredPersons.length === 1)}
                        />
                        {this.referrerJourney && <HeadsUpPanel wordingHtml={this.headsUpContent}/>}
                        {this.renderCarPanels()}
                        {showAddAnotherCarSection && <AddCarPanel renewalPaymentFailed={renewalPaymentFailed}/>}
                        {/* This is commented out on purpose, as this will have to be readded for the May release*/}
                        {/* <AddDriverPanel disabled={true}/> */}
                        {this.pluginTemplates.renderBackLink("Back", false, "/dashboard/monthlySubscription")}
                    </div>}
                    <FalconFooter/>
                </React.Fragment>
            );
        } else {
            return <Overlay show={true}/>
        }
    }

    private renderCarPanels() {
        if (this.state.party && this.state.policies && this.state.allPolicies && this.state.subscription && this.state.carToTempDriverMap) {
            const renewalPaymentFailed: boolean = this.state.subscription.renewalPaymentFailed;

            const changeOfVehicleLimitReached: boolean = this.state.party.customProperties!
                .some((property: {key: string, value: string}) => property.key === "changeOfVehicleCount" && parseInt(property.value, 10) >= this.MAX_CHANGE_OF_VEHICLE_COUNT);

            return this.state.policies.map(
                (policy: Policy, index: number) => {
                    let replacedCarPolicy: Policy | undefined;
                    if (policy.interaction.process === INTERACTION_PROCESS_MTA_REPLACE_CAR && moment().isBefore(policy.interaction.headerInfo.startDate)) {
                        replacedCarPolicy = this.state.allPolicies!.find(p => p.policyNumber === policy.policyNumber && p.interaction.agreementVersion === policy.interaction.agreementVersion - 1);
                    }
                    return (
                        <YourCarPanel
                            key={index}
                            policy={policy}
                            renewalPaymentFailed={renewalPaymentFailed}
                            replacedCarPolicy={replacedCarPolicy}
                            changeOfVehicleLimitReached={changeOfVehicleLimitReached}
                            vehicleIndex={index}
                            tempDriver={this.getTempDriver(policy)}
                            policies={this.state.policies}
                        />
                    )
                }
            );
        }
        return
    }

    private setReplaceCarPopup(): void {
        this.replaceCarOldCarMake = window.sessionStorage.getItem("oldCarMake");
        this.replaceCarOldCarVrn = window.sessionStorage.getItem("oldCarVrn");
        this.replaceCarOldCarModel = window.sessionStorage.getItem("oldCarModel");
        if (this.state.policies) {
            const interaction: any = getPolicyInteraction(window.sessionStorage.getItem("sessionInteraction"), this.state.policies);
            const newVehicle: any = interaction.vehicles[0];

            this.headsUpContent = this.renderHeadsUpContent(interaction);

            if (interaction.factors.returnPremium && interaction.factors.returnPremium > 0) {
                this.title = "Your Refund is on the way";
                this.modalContent =
                    <p>
                        We’ve saved your changes, and we’ll refund you <strong>{getAmountToDisplay(interaction.factors.returnPremium)}</strong>{' '}
                        <strong>for replacing {this.replaceCarOldCarMake}, {this.replaceCarOldCarModel} ({this.replaceCarOldCarVrn}) with{' '}
                        {newVehicle.make}, {newVehicle.model} ({newVehicle.registrationNumber}).</strong>
                        Please allow two days for it to arrive.
                    </p>
            } else if (interaction.factors.additionalPremium && interaction.factors.additionalPremium > 0) {
                this.title = "Payment was successful";
                this.modalContent =
                    <p>
                        <b>{getAmountToDisplay(interaction.factors.additionalPremium)}</b> has been taken out from your account{' '}
                        <strong>for
                            replacing {this.replaceCarOldCarMake}, {this.replaceCarOldCarModel} ({this.replaceCarOldCarVrn})
                            with{' '}
                            {newVehicle.make}, {newVehicle.model} ({newVehicle.registrationNumber})</strong>
                    </p>
            } else {
                this.title = "All done";
                this.modalContent =
                    <p>
                        We’ve saved your changes, and there’s no extra cost <strong>for replacing{' '}
                        {this.replaceCarOldCarMake}, {this.replaceCarOldCarModel} ({this.replaceCarOldCarVrn}) with{' '}
                        {newVehicle.make}, {newVehicle.model} ({newVehicle.registrationNumber})</strong>
                    </p>
            }
        }
    }

    private setMtaPopup = (): void => {
        this.mtaSuccessMessageText = window.sessionStorage.getItem("mtaSuccessMessageText");
        this.mtaHeadsUpMessageText = window.sessionStorage.getItem("mtaHeadsUpMessageText");

        if (this.state.policies) {
            const sessionInteraction: string | null = window.sessionStorage.getItem("sessionInteraction");
            const mtaVrn: string | null = window.sessionStorage.getItem("mtaVrn");
            const interactionIds: string[] = sessionInteraction ? sessionInteraction.split(",") : [];
            let interaction: any;

            if (mtaVrn) {
                for (const policy of this.state.policies) {
                    if (policy.insuredVehicles[0].registrationNumber === mtaVrn) {
                        interaction = policy.interaction;
                    }
                }
            } else if (interactionIds.length > 0) {
                interaction = getPolicyInteraction(interactionIds[0], this.state.policies);
            }

            const vehicle: any = interaction.vehicles[0];
            const vehicleInformation: string = `${capitalize(vehicle.make)}, ${capitalize(vehicle.model)} (${vehicle.registrationNumber})`;
            const additionalPremium: number = interaction.factors.additionalPremium;
            const refundPremium: number = interaction.factors.returnPremium;
            const genericChangesMessage: string = "the changes you have made";

            if (additionalPremium && additionalPremium > 0) {
                this.title = "Payment successful";
                this.modalContent =
                    <p id="mtaPaymentSuccessful">
                        We’ve saved your changes, and <b>{getAmountToDisplay(additionalPremium)}</b> has been debited from your card
                        for{' '}
                        <b>{this.mtaSuccessMessageText ? `${this.mtaSuccessMessageText}` : `${genericChangesMessage}`}</b>{' '}
                        {this.mtaSuccessMessageText ? `to ${vehicleInformation}` : ""}<br/>
                        Please allow a couple of minutes for the payment to be updated in your account.
                    </p>;
            } else if (refundPremium && refundPremium > 0) {
                this.title = "Your refund is on the way";
                this.modalContent =
                    <p id="mtaRefundSuccessful">
                        We’ve saved your changes, and we’ll refund you <b>{getAmountToDisplay(refundPremium)}</b> for{' '}
                        <b>{this.mtaSuccessMessageText ? `${this.mtaSuccessMessageText}` : `${genericChangesMessage}.`}</b>{' '}
                        {this.mtaSuccessMessageText ? `to ${vehicleInformation}. ` : ""}
                        Please allow two days for it to arrive
                    </p>;
            } else {
                this.title = "All done";
                this.modalContent =
                    <p id="mtaNoCostForChanges">
                        We’ve saved your changes, and there’s no extra cost for{' '}
                        <b>{this.mtaSuccessMessageText ? `${this.mtaSuccessMessageText}` : `${genericChangesMessage}.`}</b>
                    </p>;
            }

            if (this.mtaHeadsUpMessageText === "genericMessage") {
                this.headsUpContent =
                    <p>Heads up - Your changes to {vehicleInformation} have been saved</p>;
            } else {
                this.headsUpContent =
                    <p>Heads up - You just <b>{this.mtaHeadsUpMessageText}</b> to {vehicleInformation}</p>;
            }
        }
    };

    private setGreenCardPopup = (): void => {
        this.greenCardVrn = window.sessionStorage.getItem("greenCardVrn");
        this.greenCardCaravanVrn = window.sessionStorage.getItem("greenCardCaravanVrn");
        this.title = "We’ve received your Green Card request";

        if (this.state.policies && this.greenCardCaravanVrn) {
            const vehicle: any = this.state.policies.filter(p => p.insuredVehicles[0].registrationNumber === this.greenCardVrn)[0].insuredVehicles[0];
            this.modalContent =
                <p>
                    Your Green Card for {capitalize(vehicle.make)}, {capitalize(vehicle.model)} ({vehicle.registrationNumber}) and Trailer or Caravan ({capitalize(this.greenCardCaravanVrn)}) will be available in ‘Your documents’ for you to print at home on white paper.
                    Remember to carry it with you on the trip with your other documents
                </p>;

            this.headsUpContent =
                <p>
                    Heads up - You just <strong>requested a Green Card </strong>
                    for {capitalize(vehicle.make)}, {capitalize(vehicle.model)} ({vehicle.registrationNumber}) and Trailer or Caravan ({capitalize(this.greenCardCaravanVrn)})
                </p>
        }
        else if (this.state.policies) {
            const vehicle: any = this.state.policies.filter(p => p.insuredVehicles[0].registrationNumber === this.greenCardVrn)[0].insuredVehicles[0];
            this.modalContent =
                <p>
                    Your Green Card for {capitalize(vehicle.make)}, {capitalize(vehicle.model)} ({vehicle.registrationNumber}) will be available in ‘Your documents’ for you to print at home on white paper.
                    Remember to carry it with you on the trip with your other documents
                </p>;

            this.headsUpContent =
                <p>
                    Heads up - You just <strong>requested a Green Card </strong>
                    for {capitalize(vehicle.make)}, {capitalize(vehicle.model)} ({vehicle.registrationNumber})
                </p>
        }
    };

    private setPermanentDriverPopup = (): void => {
        if (this.state.policies) {
            const interactionId: any = window.sessionStorage.getItem("sessionInteraction");
            const interaction: any = getPolicyInteraction(interactionId, this.state.policies);
            const addedDriver: any = interaction.additionalDrivers[interaction.additionalDrivers.length - 1];

            if (interaction.factors.additionalPremium && interaction.factors.additionalPremium > 0) {
                this.title = "Payment successful";
                this.modalContent =
                    <p>
                        We've saved your changes, and <b>{getAmountToDisplay(interaction.factors.additionalPremium)}</b>{' '}
                        has been debited from your card for
                        adding <b>{addedDriver.firstName} {addedDriver.lastName}</b>{' '}
                        as a <b>permanent driver
                        to {interaction.vehicles[0].make}, {interaction.vehicles[0].model}</b> ({interaction.vehicles[0].registrationNumber})<br/>
                        Please allow a couple of minutes for the payment to be updated in your account.
                    </p>;
            } else if (interaction.factors.returnPremium && interaction.factors.returnPremium > 0) {
                this.title = "Your Refund is on the way";
                this.modalContent =
                    <p>
                        We've saved your changes, and we'll refund you <strong>{getAmountToDisplay(interaction.factors.returnPremium)}</strong>
                        <br/>
                        for adding<b> {addedDriver.firstName} {addedDriver.lastName} </b>
                        as a <b>permanent driver to {interaction.vehicles[0].make}, {interaction.vehicles[0].model}</b> ({interaction.vehicles[0].registrationNumber}).
                        Please allow two days for it to arrive
                    </p>
            } else {
                this.title = "All done";
                this.modalContent =
                    <p>
                        We’ve saved your changes, and there’s no extra cost for adding <b>{addedDriver.firstName} {addedDriver.lastName} </b>
                        as a <b>permanent driver to {interaction.vehicles[0].make}, {interaction.vehicles[0].model}</b> ({interaction.vehicles[0].registrationNumber})
                    </p>;
            }

            this.headsUpContent =
                <p>
                    Heads up - You just added <b>{addedDriver.firstName} {addedDriver.lastName} </b>
                    as a <b>permanent driver to {interaction.vehicles[0].make}, {interaction.vehicles[0].model}</b> ({interaction.vehicles[0].registrationNumber})
                </p>
        }
    };

    private setTemporaryDriverPopup = (): void => {
        const mtaVrn: string | null = window.sessionStorage.getItem("mtaVrn");
        const mtaAdditionalPremium: string | null = window.sessionStorage.getItem("mtaAdditionalPremium");

        if (this.state.policies && this.state.carToTempDriverMap && mtaVrn) {
            const addedDriver: any = this.state.carToTempDriverMap.get(mtaVrn);
            const vehicle: any = this.state.policies.filter((p) => p.insuredVehicles[0].registrationNumber === mtaVrn)[0].insuredVehicles[0];

            this.title = "Payment successful";
            this.modalContent =
                <p>
                    We’ve saved your changes, and <b>{getAmountToDisplay(mtaAdditionalPremium)} </b>has been debited from your card for
                    adding
                    <b> {addedDriver.firstName} {addedDriver.lastName} </b>
                    as a <b>temporary driver to {vehicle.make}, {vehicle.model}</b> ({vehicle.registrationNumber})<br/>
                    Please allow a couple of minutes for the payment to be updated in your account.
                </p>;

            this.headsUpContent =
                <p>
                    Heads up - You just added <b>{addedDriver.firstName} {addedDriver.lastName} </b>
                    as a <b>temporary driver to {vehicle.make}, {vehicle.model}</b> ({vehicle.registrationNumber})
                </p>
        }
    };

    private setReactivateCarPopup = (): void => {

        if (this.state.policies) {
            const interaction: any = getPolicyInteraction(window.sessionStorage.getItem("sessionInteraction"), this.state.policies);
            const vehicle: any = interaction.vehicles[0];

            this.headsUpContent =
                <p>
                    Heads up - You just <strong>reactivated {vehicle.make}, {vehicle.model}</strong> ({vehicle.registrationNumber})
                </p>;

            if (interaction.factors.additionalPremium && interaction.factors.additionalPremium > 0) {
                this.title = "Payment successful";
                this.modalContent =
                    <p>
                        We’ve saved your changes, and <b>{getAmountToDisplay(interaction.factors.additionalPremium)}</b> has been debited
                        from your card {' '}
                        for <strong>reactivating {vehicle.make}, {vehicle.model}</strong> ({vehicle.registrationNumber})
                        car cover.<br/>
                        Please allow a couple of minutes for the payment to be updated in your account.
                    </p>
            } else {
                this.title = "All done";
                this.modalContent =
                    <p>
                        We’ve saved your changes, and there’s no extra cost for reactivating
                        <strong> {vehicle.make}, {vehicle.model}</strong> ({vehicle.registrationNumber}) car cover
                    </p>
            }
        }
    };

    private setReactivateAllCarsPopup = (): void => {

        if (this.state.policies) {
            const additionalPremium: string | null = window.sessionStorage.getItem("additionalPremium");

            this.headsUpContent =
                <p>
                    Heads up - You just <strong>reactivated your car cover(s)</strong>
                </p>;

            if (additionalPremium && additionalPremium !== "0") {
                this.title = "Payment successful";
                this.modalContent =
                    <p>
                        We’ve saved your changes, and <b>{getAmountToDisplay(additionalPremium)}</b> has been debited from your card{' '}
                        for <strong>reactivating your car cover(s)</strong>
                        <br/>
                        Please allow a couple of minutes for the payment to be updated in your account.
                    </p>
            } else {
                this.title = "All done";
                this.modalContent =
                    <p>We’ve saved your changes, and there’s no extra cost for reactivating your car cover(s)</p>
            }
        }
    };

    private setAddCarPopup = (): void => {

        if (this.state.policies) {
            const interaction: any = getPolicyInteraction(window.sessionStorage.getItem("sessionInteraction"), this.state.policies);
            const vehicle: any = interaction.vehicles[0];

            this.headsUpContent =
                <p>
                    Heads up - You just <strong>added car </strong>
                    <strong>{vehicle.make}, {vehicle.model}</strong> ({vehicle.registrationNumber})
                </p>;

            if (interaction.factors.additionalPremium) {
                this.title = "Payment successful";
                this.modalContent =
                    <p>
                        We’ve saved your changes, and <b>{getAmountToDisplay(interaction.factors.additionalPremium)}</b> has been debited
                        from your card{' '}
                        for <strong>adding car {vehicle.make}, {vehicle.model}</strong> ({vehicle.registrationNumber})
                        to your subscription<br/>
                        Please allow a couple of minutes for the payment to be updated in your account.
                    </p>
            } else {
                this.title = "All done";
                this.modalContent =
                    <p>
                        We’ve saved your changes, and there’s no extra cost for adding car
                        <strong> {vehicle.make}, {vehicle.model}</strong> ({vehicle.registrationNumber}) to your subscription
                    </p>
            }
        }
    };

    private setEditCarsRegistrationPopup = (): void => {
        this.editCarsRegistrationOldVrn = window.sessionStorage.getItem("oldCarVrn");

        if (this.state.policies) {
            const interaction: any = getPolicyInteraction(window.sessionStorage.getItem("sessionInteraction"), this.state.policies);
            const newVehicle: any = interaction.vehicles[0];

            this.headsUpContent =
                <p>
                    Heads up - You just <strong>replaced </strong>
                    ({this.editCarsRegistrationOldVrn}) with <strong>({newVehicle.registrationNumber})</strong>
                </p>;

            this.title = "All done";
            this.modalContent =
                <p>
                    We’ve saved your changes, there’s no extra cost for replacing <strong>({this.editCarsRegistrationOldVrn})</strong> with <strong>({newVehicle.registrationNumber})</strong>.{' '}
                    We’ll check your details with DVLA, if we can’t match your new registration number we’ll cancel your subscription.
                </p>
        }
    };

    private getTempDriver = (policy: Policy): any => {
        return this.state.carToTempDriverMap!.get(policy.insuredVehicles[0].registrationNumber);
    };

    private renderHeadsUpContent(interaction: any): React.ReactNode {

        const endDate: moment.Moment = moment.utc(interaction.headerInfo.startDate, moment.ISO_8601);

        let dateString: string;
        if (endDate.isSame(moment(), 'day')) {
            dateString = `Today, ${endDate.format("D MMM YYYY")}, 23:59`;
        } else if (endDate.isSame(moment().add(1, 'day'), 'day')) {
            dateString = `Tomorrow, ${endDate.format("D MMM YYYY")}, 23:59`;
        } else {
            dateString = `on ${endDate.format("D MMM YYYY")}, 23:59`;
        }

        return (
            <p>
                Heads up - the cover for {this.replaceCarOldCarMake}, {this.replaceCarOldCarModel} ({this.replaceCarOldCarVrn}) will end{' '}
                {dateString}
            </p>
        );
    }
}
